import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-plus-circle',
  templateUrl: './icon-plus-circle.component.html',
  styles: []
})
export class IconPlusCircleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
